var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2"},[_c('p',{staticClass:"font-weight-bolder mb-0"},[_vm._v("\n    Início: "+_vm._s(_vm.$moment(_vm.begin).format('DD/MM/YYYY HH:mm'))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"font-weight-bolder mb-0"},[_vm._v("\n    Fim: "+_vm._s(_vm.$moment(_vm.end).format('DD/MM/YYYY HH:mm'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }